import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHome,
    faUserGraduate,
    faChalkboardTeacher,
    faSchool,
    faBook,
    faMarker,
    faChartLine,
    faUsers,
    faChalkboard,
    faLayerGroup,
    faBookOpen,
    faSignOutAlt,
  } from "@fortawesome/free-solid-svg-icons";

  import { useNavigate } from "react-router-dom";
import { faPlus, faFileImport, faEdit } from "@fortawesome/free-solid-svg-icons";
import "./manageTeachers.css";
import "./dashboard.css";
import { Link } from 'react-router-dom'; // Import Link component
import Sidebar from "./Sidebar";


const ManageTeachers = () => {

  const navigate = new useNavigate;

  return (
    <div className="dashboard-wrapper">
      {/* Sidebar */}
      <Sidebar/>
      {/* Main Content */}
      <div className="main-content">
        {/* Header */}
        <header className="header" style={{marginTop:'2%'}}>
          <h1>Sample Data Files</h1>
        </header>

        {/* Main Section */}
        <section className="content">
          <div className="cards">
            <div className="card card-add-studentO" onClick={()=>navigate('/Specific-Test-Sheet-Sample')}>
              {/* <FontAwesomeIcon icon={faPlus} className="card-icon" /> */}
              <img src="/images/icons/manage.webp" alt="Description" width={110} height={90} />

              <h3>Specific Sheet</h3>
            </div>
            <div className="card card-add-csvO" onClick={()=>navigate('/addTeachersCSV')}>
              {/* <FontAwesomeIcon icon={faFileImport} className="card-icon" /> */}
              <img src="/images/icons/view-sec.jpg" alt="Description" width={110} height={90} />

              <h3>Multiple Sheets</h3>
            </div>
          
          </div>
        </section>

        {/* Footer */}
        <footer className="footer">
          <p>© 2024 My School. All Rights Reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default ManageTeachers;
